<script>
import MenuRenderView from '@dynameat/MenuRenderView.vue';
import Component from 'vue-class-component';
import { createErrorNotification } from '@ulibs/unnotificationsqueue';
import { Prop, Watch } from 'vue-property-decorator';
import { Menu } from '@pointOfSale/models';
import { MapActions, MapGetters } from '@core/helpers/decorators';

@Component
@MapGetters(['selectedMenuForGrid', 'cacheData'])
@MapActions(['preview'])
export default class MenuRenderPreview extends MenuRenderView {
  @Prop({ type: Menu }) menu;

  created() {
  }

  async loadMenuRenderData() {
    try {
      await this.preview();
    } catch (e) {
      this.addNotification(createErrorNotification('cacheLoadingError', {}, 3000));
    }
  }

  setUpStyles() {
    const element = document.getElementById('app');
    element.style.height = '100%';
  }

  @Watch('selectedMenuForGrid')
  onSelectedMenuForGridChange(updatedValue, oldValue) {
    if (updatedValue !== oldValue) {
      this.loadMenuRenderData();
    }
  }

  @Watch('cacheData')
  onCacheDataChange(updatedValue, previousValue) {
    if (updatedValue !== previousValue) {
      this.cache = this.cacheData;
    }
  }
}
</script>
